/**
 * @desc 新增年度销售计划详情
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: Array<defs.TheNewAnnualSalesPlan>,
): Promise<defs.StandardReturn<boolean>> {
  return defHttp.post({
    url: '/web/sale/year/add',
    data,
  });
}

export function mock(
  data: Array<defs.TheNewAnnualSalesPlan>,
): Promise<defs.StandardReturn<boolean>> {
  return defHttp.post({
    url: '/mock/web/sale/year/add',
    data,
  });
}
